var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"page-loader",attrs:{"id":"pageLoadingDiv"}},[_c('v-progress-circular',{attrs:{"id":"progress","size":"100","color":_vm.colors.orange,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }